import nQueryObject from "./nQueryObject.js";

export default class nQueryElement extends nQueryObject {
	constructor(objects) {
		super(objects);
	}
}
